import { render } from "./MergeTagsSourcesModal.vue?vue&type=template&id=53718436&scoped=true"
import script from "./MergeTagsSourcesModal.vue?vue&type=script&lang=js"
export * from "./MergeTagsSourcesModal.vue?vue&type=script&lang=js"

import "./MergeTagsSourcesModal.vue?vue&type=style&index=0&id=53718436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53718436"]])

export default __exports__